<!--
  @description 菜单管理
  @author xiehan
  @date 2018/12/12
-->
<template>
  <div class="roleManageHome__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('roleManage.name')">
        <el-input v-model="searchForm.name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          v-g-rac="gRac('roleManage_search')"
          @click="search"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary"
          v-g-rac="gRac('roleManage_add')"
          @click="addRole"
          v-text="$t('common.add')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import roleManageBiz from '@/logic/systemSetting/roleManageBiz'
  import table from '@/components/mixins/table'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, table],
    data () {
      return {
        searchForm: {
          name: ''
        },
        tableControl: [
          {
            label: this.$t('common.delete'),
            callback: (row, index, data) => {
              this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
              }).then(() => {
                roleManageBiz.deleteRole({ id: row.id }).then(() => {
                  this.$message({
                    message: this.$t('common.success'),
                    type: 'success'
                  })
                  this.searchTable()
                })
              }).catch(() => {})
            },
            rac: () => this.gRac('roleManage_delete')
          }, {
            label: this.$t('common.edit'),
            callback: (row, index, data) => {
              this.$router.push({ name: 'handlerRoleManage', query: { id: row.id } })
            },
            rac: () => this.gRac('roleManage_amend')
          }
        ]
      }
    },
    methods: {
      initTable () {
        this.tInitTable({
          lanKey: 'roleManage.table',
          head: ['name', 'description', 'creator', 'createTime', 'enabled'],
          requestFun: this.searchTable
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      addRole () {
        this.$router.push({ name: 'handlerRoleManage' })
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        roleManageBiz.findAll(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.createTime = TimeFormat.getFormatTime(item.createTime)
              item.enabled = item.enabled ? this.$t('roleManage.usable') : this.$t('roleManage.unusable')
            })
          }
          this.tData = data
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'roleManage' && from.name === 'handlerRoleManage') {
          this.searchTable()
        }
      }
    },
    mounted () {
      this.initTable()
      this.searchTable()
    }
  }
</script>